import React from 'react';
import './App.css';
import './components/AppFooter.css';
import './Footer.css';
import AppFooter from './components/AppFooter';
import { GROUP, DIVISIONS, BRAND } from './CompanyInfo';

/**
 * The public site footer.
 *
 * Was a single column for PRIMARY plus a `Statutory` and a `Bank details`
 * column - the other two divisions were nowhere in the footer at all. It now
 * lists every division the way the About Us page does, each with its own
 * address, phone numbers, email and GSTIN.
 */
function Footer() {
    return (
        <>
            <footer className="footer siteFooter">
                <div className="siteFooterTop">
                    <h6 className="siteFooterHead">Our divisions</h6>
                </div>

                <div className="siteFooterInner">
                    {DIVISIONS.map((division) => (
                        <div className="siteFooterCard" key={division.key}>
                            <div className="siteFooterCardHead">
                                <img
                                    className="siteFooterLogo"
                                    src={division.logo}
                                    alt={division.name}
                                />
                                <div className="siteFooterTitle">
                                    <span className="siteFooterName">{division.name}</span>
                                    <span className="siteFooterLabel">{division.label}</span>
                                </div>
                            </div>

                            <address className="siteFooterAddress">
                                {division.addressLines.map((line, i) => (
                                    <React.Fragment key={i}>
                                        {line}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </address>

                            <p className="siteFooterLine">
                                <span className="siteFooterKey">Ph</span>
                                <span className="siteFooterPhones">
                                    {division.phones.map((phone, i) => (
                                        <a
                                            key={i}
                                            href={'tel:' + phone.replace(/[^\d+]/g, '')}
                                        >
                                            {phone}
                                        </a>
                                    ))}
                                </span>
                            </p>

                            <p className="siteFooterLine">
                                <span className="siteFooterKey">Email</span>
                                <a href={'mailto:' + division.email}>{division.email}</a>
                            </p>

                            <p className="siteFooterLine siteFooterGst">
                                <span className="siteFooterKey">GSTIN</span>
                                <span className="siteFooterGstNo">{division.gst}</span>
                            </p>
                        </div>
                    ))}
                </div>

                <div className="siteFooterBar" style={{ borderTopColor: BRAND.green }}>
                    {GROUP.name} &middot; {GROUP.since}
                </div>
            </footer>

            <AppFooter />
        </>
    );
}

export default Footer;
